<template>
  <div class="modal-oce-play">
    <hr />
    <div class="row">
      <div class="col-lg-6">
        <bp-select
          v-model="form.product_id"
          id="product-select"
          label="Nome do produto"
          required
          class="mb-4"
          placeholder="Selecionar produto"
          :disabled="isEdit"
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </div>
      <div class="col-lg-6">
        <!-- <checkboxes-dropdown
          class="mt-5"
          id="url-status"
          label="Quando encaminhar:"
          :disabled="isEdit"
          :placeholder="statusPlaceholder"
        >
          <template>
            <b-form-radio-group
              v-model="form.url_status"
              stacked
              :options="statusOptions"
            />
          </template>
        </checkboxes-dropdown> -->
        <bp-select
          id="url-status"
          v-model="form.url_status"
          label="Quando encaminhar:"
          :disabled="isEdit"
          :placeholder="statusPlaceholder"
          :options="statusOptions"
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.description"
          id="description"
          label="Descrição da integração (Opcional)"
          placeholder="Digite a descrição da integração"
          :errors="errors.description"
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.internal_id"
          type="number"
          id="internal-id"
          label="ID externo do produto"
          placeholder="Digite o ID externo"
          :errors="errors.internal_id"
          required
        />
      </div>
    </div>
    <b-form-checkbox switch v-model="form.has_classes" class="mt-5">
      Possui turma?
    </b-form-checkbox>

    <div class="submit-buttons">
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
      <bp-button
        label="Integrar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        [
          "description",
          "internal_id",
          "url_status",
          "product_id",
          "has_classes",
          "url"
        ],
        {
          has_classes: false
        },
        this.integrationToEdit
      ),
      statusOptions: [
        { id: "enable", name: "Compra aprovada" },
        { id: "disable", name: "Reembolso" }
      ]
    };
  },
  computed: {
    statusPlaceholder() {
      return (
        this.statusOptions.find(opt => opt.value === this.form.url_status)
          ?.text || "Selecione"
      );
    },
    isValid() {
      return (
        this.form.product_id && this.form.internal_id && this.form.url_status
      );
    }
  }
};
</script>
